'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);

var _reactDndTouchBackend = require('react-dnd-touch-backend');

var _reactDndTouchBackend2 = _interopRequireDefault(_reactDndTouchBackend);

var _dndMultiBackend = require('dnd-multi-backend');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  backends: [{
    backend: _reactDndHtml5Backend2.default,
    transition: _dndMultiBackend.MouseTransition
  }, {
    backend: (0, _reactDndTouchBackend2.default)({ enableMouseEvents: true }),
    preview: true,
    transition: _dndMultiBackend.TouchTransition
  }]
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dnd-multi-backend/lib/HTML5toTouch.js
// module id = 372
// module chunks = 0